import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import Button from '@gef-ui/components/atoms/Button';
import Text, { typeConstants, weightConstants } from '@gef-ui/components/atoms/Text';
import ComponentLoader from '@gef-ui/components/molecules/ComponentLoader';
import { Grid, GridAlignTypes, GridCol, GridDisplaySizes } from '@gef-ui/components/organisms/Grid';
import { getLabelMessage } from '@gef-ui/localization/messages';
import { useDefaultDelegationsValue } from '../utils';
const COMPONENT_NAME = 'Logout';
const Logout = (inProps)=>{
    const props = useDefaultDelegationsValue({
        inProps,
        name: COMPONENT_NAME
    });
    const { Wrapper = React.Fragment, getIsLogoutFetchLoaded } = props;
    const logoutLoaded = useSelector(getIsLogoutFetchLoaded);
    const handleOnClick = useCallback(()=>{
        window.location.href = '/';
    }, []);
    return /*#__PURE__*/ React.createElement("div", {
        className: "Delegations"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "Tabs-main"
    }, /*#__PURE__*/ React.createElement(Wrapper, {}, /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Text, {
        className: "Delegations-logout Text--mainTitle",
        elementParagraph: true,
        type: typeConstants.PRIMARY,
        weight: weightConstants.MEDIUM
    }, getLabelMessage('logout:logout')), /*#__PURE__*/ React.createElement(Grid, {
        alignmentsForDisplays: [
            {
                [GridDisplaySizes.XS]: GridAlignTypes.CENTER
            }
        ],
        className: "Delegations-logoutButton"
    }, /*#__PURE__*/ React.createElement(GridCol, {
        sizeXS: 10,
        sizeSM: 5
    }, /*#__PURE__*/ React.createElement(ComponentLoader, {
        isLoading: !logoutLoaded,
        loaded: logoutLoaded
    }, /*#__PURE__*/ React.createElement(Button, {
        primary: true,
        block: true,
        onClick: handleOnClick,
        label: getLabelMessage('logout:logAgain')
    }))))))));
};
Logout.propTypes = {
    Wrapper: PropTypes.any,
    getIsLogoutFetchLoaded: PropTypes.func
};
export default Logout;
